import { ConnectionItem, Flex, Image, Text } from "@wayflyer/flyui";
import { useState } from "react";
import { useIntl } from "react-intl";
import { connectByPath } from "shared-ui";
import { useCustomerAppConfig } from "undercarriage";

import { AuthCallbackPath } from "../../../api-types/connector-callbacks";
import { usePlatformConnectorProperties } from "../../../hooks/connector";
import { COMMON_MESSAGES } from "../../common-messages";
import { ConnectionsList } from "../common/connections";
import { OAuthErrorBanner } from "../common/oauth-error-banner";
import { MESSAGES } from "../message-definitions";

const CONNECTOR_SLUG = "xero";

export const XeroConnect = ({ onInitiateConnection }: { onInitiateConnection?: () => void }) => {
  const intl = useIntl();
  const {
    data: { customerDomain },
  } = useCustomerAppConfig();
  const { data: connectorProperties } = usePlatformConnectorProperties(
    customerDomain,
    CONNECTOR_SLUG,
    AuthCallbackPath.FUNDING_APPLICATION_ADD_CONNECTION
  );
  const [connectionInProgress, setConnectionInProgress] = useState(false);

  return (
    <Flex direction="column" gap="8">
      <Flex direction="column" gap="8" align="flex-start" justify="space-between">
        <OAuthErrorBanner connectorSlug={CONNECTOR_SLUG} />
        <Text>{intl.formatMessage(MESSAGES.accountingPlatformDataUsage)}</Text>
        <ConnectionsList
          connectorProperties={connectorProperties}
          connectForm={
            <ConnectionItem
              logo={
                connectorProperties.connectionLogoSrc ? <Image src={connectorProperties.connectionLogoSrc} /> : null
              }
              label={connectorProperties.name}
              actions={[
                {
                  variant: "Tertiary",
                  content: intl.formatMessage(COMMON_MESSAGES.connectAccount),
                  onAction: () => {
                    onInitiateConnection?.();
                    setConnectionInProgress(true);
                    connectByPath(connectorProperties?.connectPath);
                  },
                  loading: connectionInProgress,
                },
              ]}
            />
          }
        />
      </Flex>
    </Flex>
  );
};
